export const getTopCard = (membershipData) => {
  let topCard = null;
  const membershipList = membershipData?.data?.membership;
  if (Array.isArray(membershipList)) {
    topCard = membershipList.find((membership) => membership?.demographics?.isTopCard);
  }
  return topCard;
};

export const isVREligible = (membershipData) => {
  const topCard = getTopCard(membershipData);
  const travelBenefits = topCard?.travelBenefits || [];
  return travelBenefits.some((benefit) => benefit.name === 'SHR');
};
